import type { ReactNode } from "react";

import "./ui.css";

export interface RadioCardOption<T extends string> {
  value: T;
  title: ReactNode;
  desc?: ReactNode;
  badge?: ReactNode;
}

interface RadioCardGroupProps<T extends string> {
  name: string;
  value: T;
  onChange: (value: T) => void;
  options: RadioCardOption<T>[];
  disabled?: boolean;
}

export function RadioCardGroup<T extends string>({
  name,
  value,
  onChange,
  options,
  disabled = false,
}: RadioCardGroupProps<T>) {
  return (
    <div className="radio-group" role="radiogroup">
      {options.map((opt) => (
        <label
          key={opt.value}
          className="radio-card"
          data-checked={value === opt.value}
        >
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            disabled={disabled}
            onChange={() => onChange(opt.value)}
          />
          <span className="radio-card__indicator" />
          <span className="radio-card__body">
            <span className="radio-card__title">
              {opt.title}
              {opt.badge}
            </span>
            {opt.desc && <span className="radio-card__desc">{opt.desc}</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
